import { Box, Input } from "@mui/material";

export default function TextInputField(props) {
const {displayName, name, type, value, onChange, onKeyUp, isEditable, nameValueInterPadding=0} = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        pl: 1,
        pr: 1,
        width: 1,
      }}
    >
      <Box style={{textTransform: 'capitalize'}}>{displayName}:</Box>
      <Input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onKeyUp={onKeyUp}
        sx={{ width: 1, maxHeight: 18, pl: nameValueInterPadding }}
        disableUnderline
        readOnly={!isEditable}
      />
    </Box>
  );
}
